export const getTasks = state => state.tasks;
export const getFilters = state => state.filters.status;
